
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import TtkList from './TtkList';
const BirthadayTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Indoor Budget :</b>&nbsp;<span>{data?.indoorBudget}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Outdoor Budget :</b>&nbsp;<span>{data?.outdoorBudget}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Decor Price (Home Function) :</b>&nbsp;<span>{data?.homeFunction}</span></p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-3'>
                            <p> <DesignServicesIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Service Type :</b>&nbsp;<TtkList data={data?.serviceType} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of Working :</b>&nbsp;<TtkList data={data?.areaOfWork} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default BirthadayTTK